<template>
  <div>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="mdi-close"
      >
        {{alertMessage}}
      </v-alert>
    </v-snackbar>
    <div class="daily-check-in-container">
      <div class="daily-check-in-title">
        <span class="daily-check-in-text">{{ $t(`label.dailyCheckIn`) }}</span>
        <span>{{ $t(`label.checkIn7Days`) }}</span>
      </div>
      <div class="reward-container">
        <div class="coin-rewards">
          <div class="coin-reward" :class="getCoinsState(r)" v-for="(r, index) in dailyRewards" :key="index">
            <span class="reward-coin">{{ r.coins }}</span>
            <span class="reward-day">{{ days[r.day] }}</span>
          </div>
        </div>
        <div class="rewards-bar">
          <div class="reward-dot" :class="getCoinsState(r)" v-for="(r, index) in dailyRewards" :key="index">
          </div>
        </div>
        <div class="bottom-check-in-container">
          <app-button class="button-check-in" :action="this.onClickButton" :title="$t(this.isLoggedIn ? `button.checkInToday` :`button.loginNow`)"></app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {errorCodeHelper, locale, uiHelper} from "@/util";
import {
  REWARD_ACCEPT_CHALLENGE,
  REWARD_GET_CHECK_IN_DAY,
  REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST,
  REWARD_POST_CHECK_IN_DAY, REWARD_RESET_POST_CHECK_IN_DAY
} from "@/store/reward.module";
import {MEMBER_DETAIL} from "@/store/member.module";
import {ROUTE_NAME} from "@/constants/route.constants";

export default {
  name: 'dailyCheckIn',
  data: () => ({
    dailyRewardsDialogShow: false,
    dailyRewards: [],
    days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
    dayOfWeekNumber: new Date().getDay(),
    language: uiHelper.getLanguage().toLowerCase(),
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
  }),
  created() {
    this.getDailyCheckInPrizeList()
    this.getRewardCheckInDay();
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    rewardCheckInDay() {
      return this.$store.state.reward.checkInDay
    },
    checkInDayResponse() {
      return this.$store.state.reward.checkInDayResponse.complete
    },
    dailyCheckInPrizeList() {
      return this.$store.state.reward.dailyCheckInPrizeList
    },
    memberInfo() {
      return this.$store.state.member.info
    },
  },
  watch: {
    dailyCheckInPrizeList() {
      this.dailyRewards = this.$store.state.reward.dailyCheckInPrizeList[0].daily_coins_given
    },
    checkInDayResponse() {
      if (this.$store.state.reward.checkInDayResponse.complete) {
        this.checkInComplete(this.$store.state.reward.checkInDayResponse)
      }
    },
    alertShow() {
      if(! this.alertShow){
        this.alertSuccess = ''
        this.alertMessage = ''
      }
    }
  },
  methods: {
    getMemberDetail() {
      if (this.isLoggedIn)
        this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    getDailyCheckInPrizeList() {
      let obj = {
        id: 2
      }
      this.$store.dispatch(`${REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST}`, {obj})
    },
    getRewardCheckInDay() {
      this.$store.dispatch(`${REWARD_GET_CHECK_IN_DAY}`)
    },
    checkInDay() {
      let obj = {
        checkinDay: this.dayOfWeekNumber
      }
      this.$store.dispatch(`${REWARD_POST_CHECK_IN_DAY}`, {obj})
    },
    checkInComplete(res) {
      if (res.success) {
        this.openAlert(true, locale.getMessage(`message.checkedIn`));
        this.getMemberDetail();
        this.getRewardCheckInDay();
      } else {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(res.code));
        this.getRewardCheckInDay();
      }
      this.$store.dispatch(`${REWARD_RESET_POST_CHECK_IN_DAY}`)
    },
    getCoinsState(reward) {
      if(reward.day == this.dayOfWeekNumber) {
        return 'coin-reward-active';
      }
      // if(this.isLoggedIn) {
      //   if (this.rewardCheckInDay.includes(reward.day)) {
      //     return 'coin-reward-active';
      //   } else {
      //     if ((reward.day < this.dayOfWeekNumber && reward.day != 0) || (this.dayOfWeekNumber == 0 && reward.day != 0)) {
      //       return 'coin-reward-passed';
      //     } else {
      //       return '';
      //     }
      //   }
      // } else {
      //   return '';
      // }
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN,
        params: { lang: this.$route.params.lang }
      })
    },
    onClickButton() {
      if(this.isLoggedIn) {
        this.checkInDay();
      } else {
        this.goToLoginPage();
      }
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
  }
}
</script>

<style lang="scss">
.daily-check-in-container {
  max-height: 100%;

  .daily-check-in-title {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: black;
    .daily-check-in-text {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .reward-container {
    width: 100%;
    height: 100%;
    max-width: 620px;
    align-content: center;
    margin: 40px auto;

    .coin-rewards {
      display: flex;
      justify-content: space-between;
      font-size: 12px;

      .coin-reward {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 80px;
        height: 100px;
        align-items: center;
        border-radius: 6px;
        border: 2px solid #E5E7E8;
        background-color: #F3F5F6;

        @media (max-width: 600px) {
          width: 13%;
          height: 52px;
        }

        .reward-coin {
          position: absolute;
          top: -26px;
          width: 52px;
          height: 52px;
          border-radius: 26px;
          font-size: 14px;
          text-align: center;
          align-content: center;
          color: white;
          background-color: #47206F;

          @media (max-width: 600px) {
            top: -12px;
            width: 24px;
            height: 24px;
          }
        }

        .reward-day {
          position: absolute;
          bottom: 0;
        }
      }

      .coin-reward-active {
        border: 2px solid #47206F;
      }
    }

    .rewards-bar {
      display: flex;
      justify-content: space-between;
      width: calc(100% - 60px);
      height: 6px;
      max-width: 620px;
      align-items: center;
      margin: 32px 30px;
      background-color: #E5E7E8;

      @media (max-width: 600px) {
        width: calc(100% - 40px);
        margin: 32px 20px;
      }

      .reward-dot {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background-color: #E5E7E8;
      }

      .coin-reward-active {
        border: 2px solid #47206F;
      }
    }

    .bottom-check-in-container {
      width: 100%;
      height: 46px;
      margin-top: 20px;
      align-content: center;
      text-align: center;

      .button-check-in {
        width: 200px;
        height: 46px;
        font-size: 14px !important;
        border-radius: 6px;
        color: #ffffff;
        background-color: #FF9E2D;
      }
    }
  }
}
</style>